if (import.meta.hot) {
	import.meta.hot.accept();
}

// import { loadApp, loadModule } from '@spon/core';
import { cache, loadModule } from '@weareduet/core';
import {
	destroyBehavioursWithin,
	destroyModule,
	hydrateBehaviours,
} from '@/utils/sponLifecycle';
import 'lazysizes';

import Header from '@/globals/Header';
import CookieBanner from '@/globals/CookieBanner';
import ScrollTarget from '@/globals/ScrollTarget';
import SetVh from '@/globals/SetVh';

import '@/plugins/logger';
import webfontloader from '@/plugins/webfontloader';
import detectTab from '@/utils/detectTab';
import activeLinks from '@/utils/activeLinks';
import localLinks from '@/utils/localLinks';
import { showMessage, hideMessage } from './ui/messages';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// lazysizes swaps images in after ScrollTrigger has measured the page,
// shifting layout and leaving trigger positions stale
let lazyRefreshTimer;
document.addEventListener('lazyloaded', () => {
	clearTimeout(lazyRefreshTimer);
	lazyRefreshTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
});

webfontloader();

const globalModuleIds = [];

function mountGlobalModule(config) {
	if (cache.has(config.id)) return;

	globalModuleIds.push(config.id);
	loadModule(config);
}

webfontloader();

if (import.meta.env.DEV) {
	document.documentElement.classList.add('is-dev');
}

// load from data-behaviours
hydrateBehaviours(document.body);

mountGlobalModule({
	module: Header,
	id: 'header',
	node: document.getElementById('header'),
});

mountGlobalModule({
	module: ScrollTarget,
	id: 'scroll',
	node: document.body,
});

mountGlobalModule({
	module: SetVh,
	id: 'set-vh',
	node: document.body,
});

mountGlobalModule({
	module: CookieBanner,
	id: 'cookie-banner',
});

detectTab();
activeLinks(window.location.pathname);
localLinks();

function handleBeforeSwap({
	detail: {
		requestConfig: { triggeringEvent },
	},
	target,
}) {
	destroyBehavioursWithin(target);
}

function handleAfterSwap({ target }) {
	const results = document.getElementById('results');
	if (results) {
		results.classList.remove('is-loading');
	}

	localLinks(target);
	activeLinks(window.location.pathname);
	hydrateBehaviours(target);
}

// https://htmx.org/events
if (typeof htmx !== 'undefined') {
	// Scroll to top of `sprig` container when interacting; but only when `scroll` is in Param (eg not filtering; but probably pagination)
	htmx.on('htmx:beforeSwap', handleBeforeSwap);

	// Used if sprig target != results; dont' rely on DOM change to remove `.is-loading`
	htmx.on('htmx:afterSwap', handleAfterSwap);
}

if (import.meta.hot) {
	import.meta.hot.dispose(() => {
		if (typeof htmx !== 'undefined' && typeof htmx.off === 'function') {
			htmx.off('htmx:beforeSwap', handleBeforeSwap);
			htmx.off('htmx:afterSwap', handleAfterSwap);
		}

		destroyBehavioursWithin(document.body);
		globalModuleIds.forEach(id => destroyModule(id));
	});
}
